import { setInputMask } from '../../../components/views/chat/actions';

const LimitInputNIP = {
    name: 'limitInputNIP',
    exec: () => {
        setInputMask('NIP');
    }
};

export default LimitInputNIP;
